<template>
    <div class="wrapper">
        <div class="cart-nav">
            <div class="flex cart-nav-content">
                <span v-for="(item, index) in options"
                    :key="index"
                    :class="{
                        active: index <= active
                    }">{{ item }}</span>
            </div>
            <div class="cart-line normal"></div>
            <div class="cart-line active"
                :style="{
                    width: `${( active + 1 ) * 100 / options.length}%`
                }"></div>

        </div>
        <div class="mobile-text" v-if="isMobile && showTitleInMobile">
            {{ options[active] }}
        </div>
    </div>

</template>

<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
    props: {

        options: {

            type: Array,
            default: () => []

        },
        active: Number,
        showTitleInMobile: {
            type: Boolean,
            default: false
        }

    },
    computed: {
        isMobile ( ): boolean {

            return  this.$store.getters.isMobile;

        },
    }

});
</script>

<style scoped lang="less">
    .wrapper{
        padding: 0 15px;
    }
    .cart-nav{
        color: @font_primary;
        max-width: 1040px;
        font-size: 0.16rem;
        position: relative;
        margin: 0 auto 0.6rem;
        @media @snapeak_mobile{
            font-size: 12px;
            margin-top: 32px;
            margin-bottom: 24px;
        }
        .cart-nav-content{
            justify-content: space-between;
            span{
                z-index: 1;
                &.active{
                    color: @brand_light;
                    &::after{
                        background-color: @brand_light;
                    }
                }
                &::after{
                    content: '';
                    display: block;
                    width: 8px;
                    height: 8px;
                    background-color: #B6B6B6;
                    border-radius: 100%;
                    margin: 3px auto 0;
                }
                &:nth-child(2){
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }
        .cart-line{
            height: 1px;
            position: absolute;
            bottom: 4px;
            &.normal{
                background-color: #B6B6B6;
                width: 100%;
            }
            &.active{
                background-color: @brand_light;
            }
        }

    }
.mobile-text {
    margin-top: 24px;
    margin-bottom: 20px;
    text-align: center;
    font-family: @font_01;
    font-size: 30px;
    font-weight: normal;
    line-height: normal;
}
</style>
